import { useAuth } from "../../context/AuthContext";
import { Navigate } from "react-router-dom";

const HomeRedirect = () => {
    const { user, loading } = useAuth();

    if (loading) return null; // Or a spinner

    if (!user) return <Navigate to="/login" replace />;

    if (user.role === 'admin') return <Navigate to="/admin/dashboard" replace />;
    if (user.role === 'mentor') return <Navigate to="/mentor/dashboard" replace />;
    if (user.role === 'mentee') return <Navigate to="/mentee/dashboard" replace />;

    return <Navigate to="/dashboard" replace />;
};

export default HomeRedirect;